import parse from 'html-react-parser';
import gsap from 'gsap';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { useAppContext } from '../../context/appContext';
import { useEffect, useRef, useState } from 'react';
import { SliderModalGallery } from './SliderModalGallery';
import ImageComponent from '../Image/Image';
import styles from './SliderModal.module.scss';
import { setOverflow, unsetOverflow } from '../../helpers/overflow';

export const SliderModal = () => {
    const breakpoint = useBreakpoint()
    const { appData, updateAppData } = useAppContext();
    const [ data, setData ] = useState(null);
    const timelineRef = useRef(null);
    const overlayRef = useRef(null);
    const contentRef = useRef(null);

    const handlerClose = () => {
        timelineRef.current?.timeScale(1.5).reverse().then(() => {
            setData(null);
            updateAppData({ sliderModal: false });
        });
    }

    useEffect(() => {
        const _data = appData.sliderModal;
      
        const handleEscapePress = (event) => {
            if (event.key === 'Escape') handlerClose()
        }

        if(_data && _data.id) {
            setData(_data);
            window.addEventListener('keydown', handleEscapePress);
        }

        return () => {
            window.removeEventListener('keydown', handleEscapePress)
        }
    }, [appData.sliderModal])

    useEffect(() => {
        if(data !== null) {
            setOverflow();
        } else {
            unsetOverflow();
        }

        return () => {
            unsetOverflow();
        }
    }, [data])

    useEffect(() => {
        const overlay = overlayRef.current;
        const content = contentRef.current;
        
        if(overlay && content && data) {
            timelineRef.current = gsap
                .timeline({ paused: true })
                .fromTo(overlay, { opacity: 0 }, { opacity: 1 }, '')
                .fromTo(content, { yPercent: 100, opacity: 0 }, { yPercent: 0, opacity: 1 }, '')

            timelineRef.current.play();

            return () => {
                timelineRef.current.kill();
                timelineRef.current = null;

                gsap.set([overlay, content], { clearProps: 'all' })
            }
        }
    }, [data])

    return data ? (
        <div className={ styles.modal }>
            <div ref={ overlayRef } className={ styles.overlay } onClick={ handlerClose } style={ { opacity: 0 } } />
            <div ref={ contentRef } className={ styles.content } style={ { opacity: 0 } }>
                { breakpoint === 'desktop' ? (
                    <>
                        <SliderModalGallery className={ styles.slider } slides={ data.slider } />
                        <div className={ styles.aside }>
                            <div className={ styles.scroll }>
                                <button type="button" className={ styles.close } onClick={ handlerClose } />
                                <div className={ styles.logo }>
                                    <ImageComponent src={ data.logo } />
                                </div>
                                <div className={ styles.title }>{ parse(data.title) }</div>
                                <p className={ styles.text }>{ parse(data.text) }</p>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className={ styles.aside }>
                        <div className={ styles.scroll }>
                            <div className={ styles.top }>
                                <div className={ styles.title }>{ parse(data.title) }</div>
                                <button type="button" className={ styles.close } onClick={ handlerClose } />
                            </div>
                            <SliderModalGallery className={ styles.slider } slides={ data.slider } />
                            <p className={ styles.text }>{ parse(data.text) }</p>
                        </div>
                    </div>
                ) }
            </div>
        </div>
    ) : null
}
